/* MoreActionsCTA.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["triggerRef"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _5 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _4 = "._19pk1fcb{margin-top:var(--ds-space-025)}";
import Badge from '@atlaskit/badge';
import { IconButton } from '@atlaskit/button/new';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import MoreIcon from '@atlaskit/icon/glyph/more';
import { BodyNormal, FinePrint } from '@atlassian/mpac-primitives';
import React, { useState } from 'react';
import { useWatchApp } from '../WatchApp';
const _3 = "._jq8g8pqr button{height:2.5rem}";
const _2 = "._14hp8pqr button{width:2.5rem}";
const _ = "._18u01eps{margin-left:var(--ds-space-100)}";
export const WatchAppTrigger = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_18u01eps _14hp8pqr _jq8g8pqr", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  WatchAppTrigger.displayName = 'WatchAppTrigger';
}
const WatchAppSubtext = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = FinePrint,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _5]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1fcb _syaz1jij", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  WatchAppSubtext.displayName = 'WatchAppSubtext';
}
export const MoreActionsCTA = _ref3 => {
  let {
    watchersInfo,
    appKey,
    isLoggedIn,
    loginHref
  } = _ref3;
  const {
    watchingStatus,
    watcherCount,
    handleStopWatching,
    handleStartWatching
  } = useWatchApp({
    appKey,
    initialWatchingStatus: (watchersInfo === null || watchersInfo === void 0 ? void 0 : watchersInfo.isUserWatchingApp) || false,
    initialWatcherCount: (watchersInfo === null || watchersInfo === void 0 ? void 0 : watchersInfo.watchersCount) || 0,
    userLoggedIn: Boolean(isLoggedIn),
    onWatchSuccess: () => {
      setFlagType('watch-success');
    },
    onUnwatchSuccess: () => {
      setFlagType('unwatch-success');
    }
  });
  const [flagType, setFlagType] = useState(null);
  function getFlagContent() {
    if (flagType === 'watch-success') {
      return {
        title: 'You are now watching this app',
        description: 'You will receive email updates whenever newer versions are released.'
      };
    }
    if (flagType === 'unwatch-success') {
      return {
        title: 'You are no longer watching this app',
        description: 'You will no longer receive email updates whenever newer versions are released.'
      };
    }
    return null;
  }
  const flagContent = getFlagContent();
  const onWatchClick = () => {
    if (!isLoggedIn) return;
    return watchingStatus ? handleStopWatching : handleStartWatching;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownMenu, {
    placement: "bottom-end",
    trigger: _ref4 => {
      let {
          triggerRef
        } = _ref4,
        props = _objectWithoutProperties(_ref4, _excluded3);
      return /*#__PURE__*/React.createElement(WatchAppTrigger, _extends({}, props, {
        ref: triggerRef
      }), /*#__PURE__*/React.createElement(IconButton, {
        spacing: "default",
        icon: MoreIcon,
        appearance: "default",
        label: "More actions"
      }));
    }
  }, /*#__PURE__*/React.createElement(DropdownItemGroup, null, /*#__PURE__*/React.createElement(DropdownItem, {
    href: !isLoggedIn ? loginHref : undefined,
    onClick: onWatchClick()
  }, /*#__PURE__*/React.createElement(BodyNormal, null, watchingStatus ? 'Unwatch App' : 'Watch App', ' ', /*#__PURE__*/React.createElement(Badge, {
    max: false
  }, watcherCount)), /*#__PURE__*/React.createElement(WatchAppSubtext, null, watchingStatus ? 'Cancel email alerts for new version releases.' : 'Get email alerts for new version releases.')))), /*#__PURE__*/React.createElement(FlagGroup, null, flagType && /*#__PURE__*/React.createElement(AutoDismissFlag, {
    onDismissed: () => setFlagType(null),
    icon: /*#__PURE__*/React.createElement(CheckCircleIcon, {
      primaryColor: "var(--ds-icon-success)",
      label: "Success"
    }),
    description: flagContent === null || flagContent === void 0 ? void 0 : flagContent.description,
    id: "watch-unwatch-success-flag",
    key: "watch-unwatch-success-flag",
    title: flagContent === null || flagContent === void 0 ? void 0 : flagContent.title
  })));
};